import * as actions from '../redux/actions';

import { KuposButton, KuposInput, KuposRadio } from '../../../common';
import React, { useState } from 'react';

import BookingSuccess from '../BookingSuccess/BookingSuccess';
import CommonService from '../../../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const ConveniosList = ({
  pbPaymentDetails,
  actions,
  t,
  history,
  onApplyDiscount,
  pullmanDiscountError,
  setPullmanDiscountError,
  isLoading,
  onSelect,
  conveniosServiceLoading,
  convenioType
}) => {
  const [rut, setRut] = useState('');
  const [error, setError] = useState('');

  const isChecked = () => {
    return (pbPaymentDetails.conveniosList || []).find(it => it.checked);
  };

  const check = i => {
    let conveniosList = CommonService.copyObject(pbPaymentDetails.conveniosList);

    console.log('convencious list', conveniosList);

    // if (conveniosList[i].checked) {
    //   conveniosList[i].checked = false;
    // } else {
    let checked = conveniosList[i].checked;
    for (let item of conveniosList) item.checked = false;
    conveniosList[i].checked = !checked;
    // }
    actions.setConvenios(conveniosList);
    if (onSelect && conveniosList[i]) onSelect(conveniosList[i].idConvenio)
  };

  const handleSubmit = r => {
    if (!CommonService.isRutValid(r)) {
      setPullmanDiscountError(`Por favor ingrese ${convenioType || 'RUT'} válido.`);
      return;
    }
    onApplyDiscount(r, isChecked());
  };

  return (
    <div className="convenios-list-container kupos-card">
      <div className="title bold-text">Convenios</div>
      <div className="convenios-list">
        {(pbPaymentDetails.conveniosList || []).map((convenio, i) => (
          <div className="convenios-list-item">
            <KuposRadio onClick={() => check(i)} checked={convenio && convenio.checked} />
            <div className="convenio-icon" onClick={() => check(i)}>
              <img src={convenio.imagenInferior} />
            </div>
          </div>
        ))}
      </div>
      {
        conveniosServiceLoading ?
          <div style={{backgroundColor:'#ccc', width:'80px', padding: 10}}><div className="loader-cricle"></div></div>
          : (isChecked() && (
            <div className="rut-input-container">
              <div className="rut-input">
                <KuposInput
                  label={`Ingresa tu ${convenioType || 'RUT'}`}
                  type="default"
                  className="kupos-border"
                  value={rut}
                  onChange={text => {
                    // setError();
                    setPullmanDiscountError('');
                    setRut(text);
                  }}
                  onBlur={text => {
                    if (!CommonService.isRutValid(text) && convenioType == 'RUT') {
                      // setError('Por favor ingrese RUT válido.');
                      setPullmanDiscountError(`Por favor ingrese ${convenioType || 'RUT'} válido.`);

                      return;
                    }
                    // handleSubmit(text)
                    setRut(convenioType  == 'RUT' ? CommonService.formatRut(text) : text);
                  }}
                  error={pullmanDiscountError}

                // errorMessage={error}
                />
                <KuposButton
                  onClick={() => {
                    // handleSubmit(rut)
                    if (!CommonService.isRutValid(rut) && convenioType == 'RUT') {
                      // setError('Por favor ingrese RUT válido.');
                      setPullmanDiscountError(`Por favor ingrese ${convenioType || 'RUT'} válido.`);

                      return;
                    }
                    onApplyDiscount(rut, isChecked());
                  }}
                  className="font12 "
                  disabled={isLoading}
                >
                  {isLoading ? <div className="loader-cricle"></div> : <span>Validar</span>}
                </KuposButton>
              </div>
              {/* {pullmanDiscountError ? (
            <div className="error  font10 ">{pullmanDiscountError}</div>
          ) : (
            error && <div className="error font10">{error}</div>
          )} */}
              {pullmanDiscountError && <div className="error font10">{pullmanDiscountError}</div>}
              {/* // {pullmanDiscountError && <div className="error  font10 ">{pullmanDiscountError}</div>} */}
            </div>
          ))}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConveniosList);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/ConveniosList/ConveniosList.js